import { Skeleton } from "@/components/ui/skeleton";

interface Props {
  count?: number;
  className?: string;
}

/**
 * LoadingCards — shimmer placeholder cho card list view (Forms, Workflows
 * pages). Doc 31.
 */
export function LoadingCards({ count = 4, className }: Props): JSX.Element {
  return (
    <div className={className ?? "space-y-2"} aria-label="Loading">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="rounded-md border bg-background p-4 flex items-center gap-3"
        >
          <Skeleton className="size-10 rounded-md shrink-0" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-1/3" />
            <Skeleton className="h-3 w-1/2" />
          </div>
          <Skeleton className="h-7 w-16 shrink-0" />
        </div>
      ))}
    </div>
  );
}
